















import { Component, Vue, Watch } from "vue-property-decorator";
import { auth, collections } from "@/configs/firebase";
import { Action, State, Mutation } from "vuex-class";
import { User } from "@/types";
import * as api from "@/lib/api";
import logger from "@/configs/logger";
import { v4 as uid } from "uuid";
import { Routes } from "@/router/routes";
import isObject from "isobject";
import { Route } from "vue-router";
import firebase from "@/configs/firebase";

@Component
export default class App extends Vue {
  @Action("setUser") setUser!: Function;
  @Action("appLoad") appLoad!: Function;
  @Action("updateConfig") updateConfig!: Function;
  @Action("cleanupSession") cleanupSession!: Function;
  @State("appLoading") appLoading!: boolean;
  @State("appLoadingError") appLoadingError!: boolean;

  unsubscribeUser!: Function;

  created() {
    this.authChangeHandler();
  }

  reload() {
    document.location.reload();
  }

  @Watch("$route")
  onRouteChange(val: Route, prev: Route) {
    if (val.name === Routes.SessionExpired) {
      this.unsubscribeUser();
    }
  }

  authChangeHandler() {
    // called when app loads/reloads or authentication state changes
    auth().onAuthStateChanged(async user => {
      if (user) {
        //firebase.analytics().setUserId(user.uid);
        await this.appLoad({ user });
        this.unsubscribeUser = collections.user
          .doc(user.uid)
          .onSnapshot(snapshot => {
            const userUpdate = snapshot.data();
            if (isObject(userUpdate)) {
              this.setUser(userUpdate);
            }
          });
      } else {
        await this.$router.replace({ name: Routes.Home });
        this.cleanupSession();
        this.unsubscribeUser();
      }
    });
  }
}
